import './game-list.scss';

import { useAppSelector } from '@/app/store/hooks';
import { selectGameMetaItems } from '@/entities/game';

import { GAMES } from '../../model/games.config';
import { GameCard } from '../GameCard';

export function GameList() {
  const gameMetaItems = useAppSelector(selectGameMetaItems);

  return (
    <div className="game-list">
      {GAMES.map((game) => {
        const meta = gameMetaItems[game.id];
        return <GameCard key={game.id} {...game} shortDesc={meta?.shortDesc} />;
      })}
    </div>
  );
}
